
























// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator';
import { IFileUpload } from '@/models/IFileUpload';

@Component({
  name: 'ImageDetailUpload',
  props:{
    fileToUpload:Object,
  }    
})
export default class ImageDetailUpload extends Vue {
  
  private fileToUpload!:IFileUpload
  private zoom = false
  
  uploadImage(){
    this.$emit("upload",this.fileToUpload)
  }

  deleteImage() {
    this.$emit("delete",this.fileToUpload)
  }
  
}
